<template>
	<div style="height: 371px">
		<iframe ref="embedElement" loading="lazy"
				width="100%"
				height="100%"
				:src="`https://watchbetter.com/tdt/category/${props.category}${props.autoplay ? '?autoplay=1' : ''}#cmpnoscreen`"
				title="watchbetter player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				allowfullscreen :onload="handleLoadedEmbed"/>
	</div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps<{
	category: 'sport_fitness' | 'outdoor' | 'food',
	autoplay?: boolean,
}>();

const embedElement = ref(null);

function handleLoadedEmbed() {
	// Manual implementation of native Watchbetter script (https://watchbetter.com/tdt-category.js)
	window.setTimeout(() => {
		embedElement.value?.contentWindow.postMessage('loadedParent', '*');
	}, 1000);
}
</script>